import { useEffect, useState } from 'react';
import { Subscription } from '~/types/models';

export interface UseTrialProgressResult {
  progress?: number;
  maxProgress?: number;
}

export const useTrialProgress = (
  subscription?: Subscription
): UseTrialProgressResult => {
  const [progress, setProgress] = useState<number>();
  const [maxProgress, setMaxProgress] = useState<number>();

  useEffect(() => {
    // Reset progress every subscription changes
    setProgress(undefined);
    setMaxProgress(undefined);

    const trialDaysLeft = subscription?.trial_info?.days_left;
    const trialPeriodDays = subscription?.trial_info?.period_days;
    let actualDaysleft = trialDaysLeft;
    let actualPeriodDays = trialPeriodDays;

    if (subscription?.cancelled && !trialDaysLeft) {
      actualDaysleft = subscription?.cancelled_days_left as number;
      actualPeriodDays =
        (subscription?.cancelled_days_used as number) + actualDaysleft;
    }

    if (actualDaysleft && actualPeriodDays) {
      setProgress(actualPeriodDays - actualDaysleft);
      setMaxProgress(actualPeriodDays);
    }
  }, [subscription]);
  return {
    progress,
    maxProgress,
  };
};
